import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-skeleton',
  templateUrl: './text-skeleton.component.html',
  styleUrl: './text-skeleton.component.scss',
  standalone: false
})
export class TextSkeletonComponent {
  @Input() showTitle: boolean = true;

  @Input() lines: number = 4;

  get linesArray(): number[] {
    return new Array(this.lines).fill(0);
  }
}